export { default } from './Fab';


//////////////////
// WEBPACK FOOTER
// ./~/@material-ui/core/esm/Fab/index.js
// module id = 402
// module chunks = 2